import Vue from "vue";
import VueRouter from "vue-router";
import authenticate from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "",
    name: "login",
    meta: {
      title: "Login",
    },
    component: () => import("@/views/Login"),
  },
  {
    path: "/admin",
    component: () => import("@/views/Admin/index.vue"),
    meta: {
      title: "Admin",
      requiresAuth: true,
    },
    children: [
      {
        path: "",
        name: "admin",
        meta: {
          title: "Login",
        },
        component: () => import("@/views/Admin/users/list.vue"),
      },
      {
        path: "profile",
        name: "profile",
        meta: {
          title: "Profile",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/profile/edit.vue"),
      },
      // Users
      {
        path: "users",
        name: "users",
        meta: {
          title: "Usuarios",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/users/list.vue"),
      },
      {
        path: "users/edit/:id",
        name: "users-edit",
        meta: {
          title: "Editar Usuario",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/users/form.vue"),
      },
      {
        path: "users/add",
        name: "users-add",
        meta: {
          title: "Agregar Usuario",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/users/form.vue"),
      },
      {
        path: "users/:user_id/professionals",
        name: "user-professionals",
        meta: {
          title: "Professionals",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/user_professionals/list.vue"),
      },
        //professionals
      {
        path: "professionals",
        name: "professionals",
        meta: {
          title: "Profesionales",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/professionals/list.vue"),
      },
      {
        path: "professionals/edit/:id",
        name: "professionals-edit",
        meta: {
          title: "Editar Profesional",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/professionals/form.vue"),
      },
      {
        path: "professionals/add",
        name: "professionals-add",
        meta: {
          title: "Agregar Profesional",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/professionals/form.vue"),
      },
        //reviews
      {
        path: "professionals/:professional_id/reviews",
        name: "professionals-reviews",
        meta: {
          title: "Reviews",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/reviews/list.vue"),
      },
        //availability_day
      {
        path: "professionals/:professional_id/availability_days",
        name: "professionals-availability-day",
        meta: {
          title: "Availability Day",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/availability_days/list.vue"),
      },
      {
        path: "professionals/:professional_id/availability_days/edit/:id",
        name: "professionals-availability-edit",
        meta: {
          title: "Editar Availability Day",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/availability_days/form.vue"),
      },
      {
        path: "professionals/:professional_id/availability_days/add",
        name: "professionals-availability-add",
        meta: {
          title: "Agregar Availability Day",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/availability_days/form.vue"),
      },
      //availability_hours
      {
        path: "professionals/:professional_id/availability_days/:availability_day_id/availability_hours",
        name: "professionals-availability-hours",
        meta: {
          title: "Availability Hour",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/availability_hours/list.vue"),
      },
      {
        path: "professionals/:professional_id/availability_days/:availability_day_id/availability_hours/edit/:id",
        name: "professionals-availability-hours-edit",
        meta: {
          title: "Editar Availability Hour",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/availability_hours/form.vue"),
      },
      {
        path: "professionals/:professional_id/availability_days/:availability_day_id/availability_hours/add",
        name: "professionals-availability-hours-add",
        meta: {
          title: "Agregar Availability Hour",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/availability_hours/form.vue"),
      },
      // Specialities
      {
        path: "specialities",
        name: "specialities",
        meta: {
          title: "Especialidades",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/specialities/list.vue"),
      },
      {
        path: "specialities/edit/:id",
        name: "specialities-edit",
        meta: {
          title: "Editar Especialidad",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/specialities/form.vue"),
      },
      {
        path: "specialities/add",
        name: "specialities-add",
        meta: {
          title: "Agregar Especialidad",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/specialities/form.vue"),
      },
      // specialities -> Appointment prices
      {
        path: "specialities/:speciality_id/appointment_prices",
        name: "appointment_prices",
        meta: {
          title: "Precios",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/specialities/appointment_prices/list.vue"),
      },
      {
        path: "specialities/:speciality_id/appointment_prices/add",
        name: "appointment-price-add",
        meta: {
          title: "Agregar Precio",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/specialities/appointment_prices/form.vue"),
      },
      {
        path: "specialities/:speciality_id/appointment_prices/edit/:id",
        name: "appointment-price-edit",
        meta: {
          title: "Editar Precio",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/specialities/appointment_prices/form.vue"),
      },
      // Tags
      {
        path: "tags",
        name: "tags",
        meta: {
          title: "Tags",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/tags/list.vue"),
      },
      {
        path: "tags/edit/:id",
        name: "tags-edit",
        meta: {
          title: "Editar Tag",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/tags/form.vue"),
      },
      {
        path: "tags/add",
        name: "tags-add",
        meta: {
          title: "Agregar Tag",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/tags/form.vue"),
      },
      // Time Range
      {
        path: "time_range",
        name: "time_range",
        meta: {
          title: "Time Ranges",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/time_range/list.vue"),
      },
      {
        path: "time_range/add",
        name: "time_range-add",
        meta: {
          title: "Agregar Time Range",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/time_range/form.vue"),
      },
      {
        path: "time_range/edit/:id",
        name: "time_range-edit",
        meta: {
          title: "Editar Time Range",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/time_range/form.vue"),
      },
      
      // Countries
      {
        path: "countries",
        name: "countries",
        meta: {
          title: "Países",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/countries/list.vue"),
      },
      {
        path: "countries/edit/:id",
        name: "countries-edit",
        meta: {
          title: "Editar País",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/countries/form.vue"),
      },
      {
        path: "countries/add",
        name: "countries-add",
        meta: {
          title: "Agregar País",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/countries/form.vue"),
      },
      // Work Requests
      {
        path: "work_requests",
        name: "work_requests",
        meta: {
          title: "Solicitudes de trabajo",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/work_requests/list.vue"),
      },
      {
        path: "work_requests/edit/:id",
        name: "work_requests-edit",
        meta: {
          title: "Editar Solicitud de trabajo",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/work_requests/form.vue"),
      },
      {
        path: "work_requests/add",
        name: "work_requests-add",
        meta: {
          title: "Agregar Solicitud de trabajo",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/work_requests/form.vue"),
      },
      // Work Requests
      {
        path: "enterprise_requests",
        name: "enterprise_requests",
        meta: {
          title: "Solicitudes empresariales",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/enterprise_requests/list.vue"),
      },
      {
        path: "enterprise_requests/edit/:id",
        name: "enterprise_requests-edit",
        meta: {
          title: "Editar Solicitud empresarial",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/enterprise_requests/form.vue"),
      },
      {
        path: "enterprise_requests/add",
        name: "enterprise_requests-add",
        meta: {
          title: "Agregar Solicitud empresarial",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/enterprise_requests/form.vue"),
      },
      // FAQ
      {
        path: "faqs",
        name: "faqs",
        meta: {
          title: "FAQs",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/faqs/list.vue"),
      },
      {
        path: "faqs/edit/:id",
        name: "faqs-edit",
        meta: {
          title: "Editar FAQ",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/faqs/form.vue"),
      },
      {
        path: "faqs/add",
        name: "faqs-add",
        meta: {
          title: "Agregar FAQ",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/faqs/form.vue"),
      },
      // Privacy
      {
        path: "privacy",
        name: "privacy",
        meta: {
          title: "Política de Privacidad",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/privacy/list.vue"),
      },
      {
        path: "privacy/edit/:id",
        name: "privacy-edit",
        meta: {
          title: "Editar PP",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/privacy/form.vue"),
      },
      {
        path: "privacy/add",
        name: "privacy-add",
        meta: {
          title: "Agregar PP",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/privacy/form.vue"),
      },
      // Terms
      {
        path: "terms",
        name: "terms",
        meta: {
          title: "Terminos y Condiciones",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/terms/list.vue"),
      },
      {
        path: "terms/edit/:id",
        name: "terms-edit",
        meta: {
          title: "Editar T&C",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/terms/form.vue"),
      },
      {
        path: "terms/add",
        name: "terms-add",
        meta: {
          title: "Agregar T&C",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/terms/form.vue"),
      },
      // Metrics
      {
        path: "metrics",
        name: "metrics",
        meta: {
          title: "Métricas",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/metrics/index.vue"),
      },
      // Discounts
      {
        path: "discounts",
        name: "discounts",
        meta: {
          title: "Descuentos",
          requiresAuth: true,
        },
        component: () => import("@/views/Admin/discounts/list.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.NODE_ENV === "production" ? "admin" : "/",
  routes,
});

router.beforeEach((toRoute, fromRoute, next) => {
  window.document.title =
    "Mentalgram - " +
    (toRoute.meta && toRoute.meta.title ? toRoute.meta.title : "Home");

  if (toRoute.matched.some((record) => record.meta.requiresAuth)) {
    if (authenticate.getters["Authenticate/isLoggedIn"]) {
      next();
      return;
    }
    next("/");
  } else if (
    (toRoute.name === "admin" || toRoute.name === "login") &&
    authenticate.getters["Authenticate/isLoggedIn"]
  ) {
    router.push("/admin/metrics");
    return;
  } else {
    next();
  }
});

export default router;
